import { Mail, Phone, MapPin } from 'lucide-react';
import { IDS, LOGO_URL } from '@/constants/testIds';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const Footer = () => {
  return (
    <footer data-testid={IDS.footer.section} className="bg-navy-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="h-14 w-14 rounded-sm overflow-hidden bg-white flex items-center justify-center">
              <img src={LOGO_URL} alt="S.K. Infrastructure" className="h-12 w-12 object-contain" />
            </div>
            <div>
              <div className="font-serif text-2xl">S.<span className="text-gold-400">K.</span> Infrastructure</div>
              <div className="text-[10px] tracking-[0.24em] uppercase text-gold-300">
                Building Today, Empowering Tomorrow
              </div>
            </div>
          </div>
          <p className="mt-6 text-sm text-white/70 max-w-md leading-relaxed">
            A registered government civil-works contractor delivering
            dependable infrastructure — from public roads and buildings to
            drainage networks and heavy civil projects.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.28em] uppercase text-gold-300 font-bold mb-5">Explore</div>
          <ul className="space-y-3 text-sm">
            {[
              ['About', 'about'],
              ['Services', 'services'],
              ['Contact', 'contact'],
            ].map(([label, id]) => (
              <li key={id}>
                <button onClick={() => scrollTo(id)} className="text-white/80 hover:text-gold-300 transition-colors">
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.28em] uppercase text-gold-300 font-bold mb-5">Reach Us</div>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-gold-300 mt-1 shrink-0" />
              <span>Plot No. 37-S, Model Town,<br />Hisar, Haryana — 125005</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-gold-300 mt-1 shrink-0" />
              <a href="tel:+919996695070" className="hover:text-gold-300">+91 99966 95070</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-gold-300 mt-1 shrink-0" />
              <a href="mailto:contact@skinfrastructures.com" className="hover:text-gold-300">
                contact@skinfrastructures.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} S.K. Infrastructure. All rights reserved.</div>
          <div className="tracking-[0.2em] uppercase">GSTIN: 06AFZFS3508P1Z1 • MSME • Railways Registered</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
